/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e,o,s){super(r,"vec2",1,(e,t,c)=>e.setUniform2fv(r,o(t,c),s),e)}}export{e as Float2sPassUniform};
